module.exports = __webpack_public_path__ + "assets/img/1_579_big.83583070.jpg";